import React from 'react';
import { View, Animated, Dimensions } from 'react-native';

import PropTypes from 'prop-types';

import styles from './styles';

const SCREEN_HEIGHT = Dimensions.get('window').height;
class ParallaxScroll extends React.Component {
  constructor() {
    super();
    this.backgroundRef = React.createRef();
    this.translateY = new Animated.Value(-60);
    this.cardPageY = new Animated.Value(0);
  }

  onScroll = () => {
    if (this.backgroundRef.current) {
      this.backgroundRef.current.measure((x, y, w, h, px, py) => {
        this.cardPageY.setValue(-py);
      });
    }
  };

  renderBackground = () => {
    const { background, style } = this.props;
    this.translateY = this.cardPageY.interpolate({
      inputRange: [-SCREEN_HEIGHT, 0],
      outputRange: [-60, 0],
      extrapolate: 'clamp',
    });
    return (
      <View ref={this.backgroundRef} style={[styles.container, style]}>
        <Animated.View
          style={[
            styles.scrollViewContentContainer,
            { transform: [{ translateY: this.translateY }] },
          ]}
        >
          {background}
        </Animated.View>
      </View>
    );
  };

  renderContent = () => {
    const { content, contentContainerStyle } = this.props;
    return <View style={[styles.contentContainer, contentContainerStyle]}>{content}</View>;
  };
  render() {
    const Background = this.renderBackground();
    const Content = this.renderContent();
    return (
      <React.Fragment>
        {Background}
        {Content}
      </React.Fragment>
    );
  }
}
ParallaxScroll.propTypes = {
  style: PropTypes.object,
  contentContainerStyle: PropTypes.object,
  background: PropTypes.element,
  content: PropTypes.element,
};
export default ParallaxScroll;
